import { defineComponent as _defineComponent } from 'vue'
import { Heading, Row, SkeletonLoader } from '@warrenbrasil/nebraska-web';

import { PortfolioDetailItem } from '@/modules/wealth/services/portfolio';

interface Props {
  details?: PortfolioDetailItem[];
  isLoading: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TechnicalDetails',
  props: {
    details: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,Heading, Row, SkeletonLoader }
}

})